import { cn } from "@/utils/classnames";
import Image from "next/image";
import { Env } from '@/libs/env';
import './index.css';

interface SpinProps extends React.ComponentProps<"div"> {
  className?: string;
  logoWidth?: number;
  logoHeight?: number;
}

const spinLogoSrc = `${Env.NEXT_PUBLIC_BRAND_ASSETS_BASE}/spin-logo.png?v=${Env.NEXT_PUBLIC_BRAND_ASSETS_VERSION}`;

function Spin({ className, logoWidth = 78, logoHeight = 42, ...props }: SpinProps) {
  return (
    <div
      data-slot="skeleton"
      className={cn("bg-surface rounded-md flex items-center justify-center", className)}
      {...props}
    >
      <div
        className="shark-wrap "
        style={{
          "WebkitMask": `url(${spinLogoSrc}) 0 0/100%`,
          "Mask": `url(${spinLogoSrc}) 0 0/100%`,
          width: `${logoWidth}px`,
        } as React.CSSProperties}
      >
        <Image priority src={spinLogoSrc} alt="spin" className="object-contain" width={logoWidth} height={logoHeight} />
      </div>
    </div>
  );
}

export { Spin };
